// import React, { useState } from "react";

// function Gallery() {
//   // State to track which photo is clicked
//   const [selectedPhoto, setSelectedPhoto] = useState(null);

//   // State to track number of photos to display
//   const [visiblePhotos, setVisiblePhotos] = useState(15);

//   // Sample photo data (replace with your own)
//   const photos = [
//     "Photos/Photo 1.jpeg",
//     "Photos/Photo 2.jpeg",
//     "Photos/Photo 3.jpeg",
//     "Photos/Photo 4.jpeg",
//     "Photos/Photo 5.jpeg",
//     "Photos/Photo 6.jpeg",
//     "Photos/Photo 7.jpeg",
//     "Photos/Photo 8.jpeg",
//     "Photos/Photo 9.jpeg",
//     "Photos/Photo 10.jpeg",
//     "Photos/Photo 11.jpeg",
//     "Photos/Photo 12.jpeg",
//     "Photos/Photo 13.jpeg",
//     "Photos/Photo 14.jpeg",
//     "Photos/Photo 15.jpeg",
//     "Photos/Photo 16.jpeg",
//     "Photos/Photo 17.jpeg",
//     "Photos/Photo 18.jpeg",
//     "Photos/Photo 19.jpeg",
//     "Photos/Photo 20.jpeg",
//     "Photos/Photo 21.jpeg",
//     "Photos/Photo 22.jpeg",
//     "Photos/Photo 23.jpeg",
//     "Photos/Photo 24.jpeg",
//     "Photos/Photo 25.jpeg",
//     "Photos/Photo 26.jpeg",
//     "Photos/Photo 27.jpeg",
//     "Photos/Photo 28.jpeg",
//     "Photos/Photo 29.jpeg",
//     "Photos/Photo 30.jpeg",
//     "Photos/Photo 1.jpeg",
//     "Photos/Photo 2.jpeg",
//     "Photos/Photo 3.jpeg",
//     "Photos/Photo 4.jpeg",
//     "Photos/Photo 5.jpeg",
//     "Photos/Photo 6.jpeg",
//     "Photos/Photo 7.jpeg",
//     "Photos/Photo 8.jpeg",
//     "Photos/Photo 9.jpeg",
//     "Photos/Photo 10.jpeg",
//     "Photos/Photo 11.jpeg",
//     "Photos/Photo 12.jpeg",
//     "Photos/Photo 13.jpeg",
//     "Photos/Photo 14.jpeg",
//     "Photos/Photo 15.jpeg",
//     "Photos/Photo 16.jpeg",
//     "Photos/Photo 17.jpeg",
//     "Photos/Photo 18.jpeg",
//     "Photos/Photo 19.jpeg",
//     "Photos/Photo 20.jpeg",
//     "Photos/Photo 21.jpeg",
//     "Photos/Photo 22.jpeg",
//     "Photos/Photo 23.jpeg",
//     "Photos/Photo 24.jpeg",
//     "Photos/Photo 25.jpeg",
//     "Photos/Photo 26.jpeg",
//     "Photos/Photo 27.jpeg",
//     "Photos/Photo 28.jpeg",
//     "Photos/Photo 29.jpeg",
//     "Photos/Photo 30.jpeg",
//   ];

//   // Function to handle photo click
//   const handlePhotoClick = (photo) => {
//     setSelectedPhoto(photo);
//   };

//   // Function to close selected photo
//   const handleClosePhoto = () => {
//     setSelectedPhoto(null);
//   };

//   // Function to handle Load More button click
//   const handleLoadMore = () => {
//     setVisiblePhotos((prevVisiblePhotos) => prevVisiblePhotos + 15);
//   };

//   return (
//     <div className="bg-primary-color">
//       {/* <div className="px-6 lg:px-16 mt-24 mb-4"> */}
//       <div className="mt-14">
//         {/* Title */}
//         <h2 className="text-gray-800 text-center text-2xl font-bold py-5 sm:py-6 md:py-8 lg:py-9 xl:py-10 2xl:py-11 mb-6">
//           Gallery
//         </h2>

//         {/* Photo grid */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
//           {photos.slice(0, visiblePhotos).map((photo, index) => (
//             <img
//               key={index}
//               src={photo}
//               alt={`Photo ${index + 1}`}
//               className="cursor-pointer hover:opacity-75 transition duration-300"
//               onClick={() => handlePhotoClick(photo)}
//             />
//           ))}
//         </div>

//         {/* Load More button */}
//         {visiblePhotos < photos.length && (
//           <div className="text-center mt-4 py-8">
//             <button
//               onClick={handleLoadMore}
//               className="bg-secondary-color border border-gray-400 shadow-md hover:shadow-lg hover:scale-105 text-white px-4 py-2 rounded hover:bg-primary-color hover:text-black transition duration-300"
//             >
//               Load More
//             </button>
//           </div>
//         )}

//         {/* Selected photo modal */}
//         {selectedPhoto && (
//           <div
//             onClick={handleClosePhoto}
//             className="fixed top-0 left-0 z-50 w-full h-full bg-black bg-opacity-75 flex justify-center items-center"
//           >
//             <div className="max-w-3xl w-full mx-4 overflow-hidden rounded-lg shadow-lg">
//               <img
//                 src={selectedPhoto}
//                 alt="Selected Photo"
//                 className="w-full h-auto"
//               />
//               <button
//                 onClick={handleClosePhoto}
//                 className="absolute top-4 right-4 text-white text-xl hover:text-gray-300 focus:outline-none"
//               >
//                 <i className="fas fa-times"></i>
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default Gallery;

// import React, { useState, useEffect, useRef } from "react";

// function LazyImage({ src, alt, className }) {
//   // custom lazy loader using IntersectionObserver
//   const imgRef = useRef();
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     const el = imgRef.current;
//     if (!el) return;

//     if ("IntersectionObserver" in window) {
//       const obs = new IntersectionObserver(
//         (entries) => {
//           entries.forEach((entry) => {
//             if (entry.isIntersecting) {
//               setVisible(true);
//               obs.unobserve(el);
//             }
//           });
//         },
//         { rootMargin: "200px" }
//       );
//       obs.observe(el);
//       return () => obs.disconnect();
//     } else {
//       // fallback
//       setVisible(true);
//     }
//   }, []);

//   return (
//     <div
//       ref={imgRef}
//       className={`w-full h-full bg-gray-800/10 flex items-center justify-center overflow-hidden ${className}`}
//       aria-busy={!visible}
//     >
//       {visible ? (
//         <img
//           src={src}
//           alt={alt}
//           loading="lazy"
//           className="w-full h-full object-cover transform transition-transform duration-700 ease-out"
//         />
//       ) : (
//         // lightweight placeholder (can customize)
//         <div className="w-12 h-12 rounded-full bg-white/6 animate-pulse" />
//       )}
//     </div>
//   );
// }

// function Gallery() {
//   // photos array: each item has src, title, category, date (ISO string)
//   const photos = [
//     {
//       src: "/Photos/Photo 1.jpeg",
//       title: "Brand Workshop",
//       category: "Events",
//       date: "2024-03-12",
//     },
//     {
//       src: "/Photos/Photo 2.jpeg",
//       title: "Campaign Shoot",
//       category: "Campaigns",
//       date: "2024-01-20",
//     },
//     {
//       src: "/Photos/Photo 3.jpeg",
//       title: "Studio Day",
//       category: "Behind the Scenes",
//       date: "2023-12-05",
//     },
//     {
//       src: "/Photos/Photo 4.jpeg",
//       title: "Launch Party",
//       category: "Events",
//       date: "2024-04-02",
//     },
//     {
//       src: "/Photos/Photo 5.jpeg",
//       title: "Creative Session",
//       category: "Campaigns",
//       date: "2023-11-18",
//     },
//     {
//       src: "/Photos/Photo 6.jpeg",
//       title: "Outdoor Shoot",
//       category: "Campaigns",
//       date: "2024-02-10",
//     },
//     {
//       src: "/Photos/Photo 7.jpeg",
//       title: "Packaging Mockups",
//       category: "Products",
//       date: "2024-05-05",
//     },
//     {
//       src: "/Photos/Photo 8.jpeg",
//       title: "Influencer Collab",
//       category: "Partnerships",
//       date: "2024-05-18",
//     },
//     {
//       src: "/Photos/Photo 9.jpeg",
//       title: "Strategy Workshop",
//       category: "Events",
//       date: "2023-09-12",
//     },
//     {
//       src: "/Photos/Photo 10.jpeg",
//       title: "Ad Set 01",
//       category: "Campaigns",
//       date: "2024-06-01",
//     },
//     {
//       src: "/Photos/Photo 11.jpeg",
//       title: "Event Collage",
//       category: "Events",
//       date: "2023-10-08",
//     },
//     {
//       src: "/Photos/Photo 12.jpeg",
//       title: "Product Setup",
//       category: "Products",
//       date: "2024-01-09",
//     },
//     {
//       src: "/Photos/Photo 13.jpeg",
//       title: "Team Offsite",
//       category: "Events",
//       date: "2023-08-22",
//     },
//     {
//       src: "/Photos/Photo 14.jpeg",
//       title: "Client Presentation",
//       category: "Presentations",
//       date: "2024-03-28",
//     },
//     {
//       src: "/Photos/Photo 15.jpeg",
//       title: "Moodboard",
//       category: "Studio",
//       date: "2023-07-01",
//     },
//   ];

//   const categories = [
//     "All",
//     "Events",
//     "Campaigns",
//     "Behind the Scenes",
//     "Products",
//     "Partnerships",
//     "Presentations",
//     "Studio",
//   ];

//   const [activeCategory, setActiveCategory] = useState("All");
//   const [sortBy, setSortBy] = useState("newest"); // newest | oldest | random
//   const [openLightbox, setOpenLightbox] = useState(null);

//   // derived filtered & sorted list
//   const filtered = photos.filter(
//     (p) => activeCategory === "All" || p.category === activeCategory
//   );

//   const sorted = (() => {
//     const copy = [...filtered];
//     if (sortBy === "newest") {
//       copy.sort((a, b) => new Date(b.date) - new Date(a.date));
//     } else if (sortBy === "oldest") {
//       copy.sort((a, b) => new Date(a.date) - new Date(b.date));
//     } else if (sortBy === "random") {
//       for (let i = copy.length - 1; i > 0; i--) {
//         const j = Math.floor(Math.random() * (i + 1));
//         [copy[i], copy[j]] = [copy[j], copy[i]];
//       }
//     }
//     return copy;
//   })();

//   // pagination / lazy reveal: we will render all cards but images lazy-load on scroll
//   // For subtle animation on filter change:
//   const [animKey, setAnimKey] = useState(0);
//   useEffect(() => {
//     setAnimKey((k) => k + 1);
//   }, [activeCategory, sortBy]);

//   // keyboard navigation for lightbox
//   useEffect(() => {
//     const handler = (e) => {
//       if (!openLightbox) return;
//       if (e.key === "Escape") setOpenLightbox(null);
//       if (e.key === "ArrowRight") {
//         // next
//         const idx = sorted.findIndex((s) => s.src === openLightbox.src);
//         const next = sorted[(idx + 1) % sorted.length];
//         if (next) setOpenLightbox(next);
//       }
//       if (e.key === "ArrowLeft") {
//         const idx = sorted.findIndex((s) => s.src === openLightbox.src);
//         const prev = sorted[(idx - 1 + sorted.length) % sorted.length];
//         if (prev) setOpenLightbox(prev);
//       }
//     };
//     window.addEventListener("keydown", handler);
//     return () => window.removeEventListener("keydown", handler);
//   }, [openLightbox, sorted]);

//   return (
//     <div className="min-h-screen bg-primary-color py-12 px-4 md:px-8 lg:px-16">
//       {/* Header */}
//       <div className="max-w-6xl mx-auto mb-8">
//         <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-highlight-color mb-3 text-center">
//           Gallery
//         </h2>
//         <p className="text-center text-highlight-color/80 max-w-2xl mx-auto mb-6">
//           A curated showcase of BrandFlow work — events, campaigns and behind
//           the scenes.
//         </p>

//         {/* Filter + Sort Bar */}
//         <div className="flex flex-col md:flex-row items-center justify-between gap-4">
//           {/* Categories (animated) */}
//           <div className="flex flex-wrap gap-3">
//             {categories.map((cat) => {
//               const active = cat === activeCategory;
//               return (
//                 <button
//                   key={cat}
//                   onClick={() => {
//                     setActiveCategory(cat);
//                     // trigger small animation key change
//                     setAnimKey((k) => k + 1);
//                   }}
//                   className={`px-4 py-2 rounded-full text-sm font-medium transition
//                     ${
//                       active
//                         ? "bg-secondary-color text-black shadow-lg"
//                         : "bg-white/6 text-highlight-color hover:bg-white/12"
//                     }`}
//                 >
//                   {cat}
//                 </button>
//               );
//             })}
//           </div>

//           {/* Sort and view controls */}
//           <div className="flex items-center gap-3">
//             <label className="text-sm text-highlight-color/80">Sort:</label>
//             <select
//               value={sortBy}
//               onChange={(e) => setSortBy(e.target.value)}
//               className="px-3 py-2 rounded-md bg-white/6 text-highlight-color border border-white/10"
//             >
//               <option value="newest">Newest</option>
//               <option value="oldest">Oldest</option>
//               <option value="random">Random</option>
//             </select>
//           </div>
//         </div>
//       </div>

//       {/* Grid */}
//       <div
//         key={animKey}
//         className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
//         // animate fade in on filter change
//         style={{ transition: "all 400ms ease" }}
//       >
//         {sorted.map((p, i) => (
//           <article
//             key={p.src + "-" + i}
//             className="group rounded-2xl overflow-hidden relative bg-white/3 border border-white/6 shadow-md"
//             style={{ minHeight: 220 }}
//           >
//             {/* image wrapper */}
//             <div
//               className="w-full h-64 md:h-56 lg:h-64 overflow-hidden relative"
//               onClick={() => setOpenLightbox(p)}
//             >
//               <LazyImage
//                 src={p.src}
//                 alt={p.title}
//                 className="transition-transform duration-700 group-hover:scale-105"
//               />
//               {/* caption overlay */}
//               <div className="absolute inset-0 flex items-end">
//                 <div className="w-full bg-gradient-to-t from-black/60 to-transparent p-4 opacity-0 group-hover:opacity-100 transform translate-y-3 group-hover:translate-y-0 transition-all duration-300">
//                   <h3 className="text-white text-lg font-semibold">
//                     {p.title}
//                   </h3>
//                   <p className="text-sm text-white/80">{p.category}</p>
//                 </div>
//               </div>
//             </div>

//             {/* meta + actions */}
//             <div className="p-4 flex items-center justify-between">
//               <div>
//                 <div className="text-sm text-highlight-color/90">
//                   {p.category}
//                 </div>
//                 <div className="text-xs text-highlight-color/70">
//                   {new Date(p.date).toLocaleDateString()}
//                 </div>
//               </div>

//               <button
//                 onClick={() => setOpenLightbox(p)}
//                 className="px-3 py-2 rounded-md bg-secondary-color text-black font-medium shadow hover:opacity-90 transition"
//               >
//                 View
//               </button>
//             </div>
//           </article>
//         ))}
//       </div>

//       {/* Lightbox Modal */}
//       {openLightbox && (
//         <div
//           className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-6"
//           onClick={() => setOpenLightbox(null)}
//         >
//           <div
//             className="relative max-w-5xl w-full rounded-xl overflow-hidden shadow-2xl bg-white/5 backdrop-blur-lg"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="relative">
//               <img
//                 src={openLightbox.src}
//                 alt={openLightbox.title}
//                 className="w-full h-auto object-contain"
//               />
//               <button
//                 onClick={() => setOpenLightbox(null)}
//                 className="absolute top-4 right-4 z-30 rounded-full bg-white/10 text-white p-2 hover:bg-white/20 transition"
//               >
//                 ✕
//               </button>
//             </div>

//             <div className="p-6">
//               <h3 className="text-2xl text-highlight-color font-semibold">
//                 {openLightbox.title}
//               </h3>
//               <p className="mt-2 text-highlight-color/80">
//                 {openLightbox.category} •{" "}
//                 {new Date(openLightbox.date).toLocaleDateString()}
//               </p>
//               <p className="mt-4 text-white/80">
//                 Click outside or press ESC to close. Use ← → to navigate.
//               </p>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default Gallery;

// import React, { useState, useRef, useEffect } from "react";

// /**
//  * GalleryPremium.jsx
//  *
//  * Premium glassmorphic 3-column gallery with lazy loading and hover captions.
//  * - Replace the `photos` array with your own image paths (or keep these sample paths).
//  * - The first item demonstrates using a local uploaded file path from the conversation.
//  */

// function GalleryPremium() {
//   const [selected, setSelected] = useState(null);
//   const [visible, setVisible] = useState([]); // indexes that are visible (for fade in)
//   const gridRef = useRef(null);

//   // Example photo list — replace with your real images as needed
//   const photos = [
//     "/mnt/data/Screenshot 2025-11-19 at 12.33.29.png", // uploaded local file (from conversation)
//     "Photos/Photo 1.jpeg",
//     "Photos/Photo 2.jpeg",
//     "Photos/Photo 3.jpeg",
//     "Photos/Photo 4.jpeg",
//     "Photos/Photo 5.jpeg",
//     "Photos/Photo 6.jpeg",
//     "Photos/Photo 7.jpeg",
//     "Photos/Photo 8.jpeg",
//     "Photos/Photo 9.jpeg",
//     "Photos/Photo 10.jpeg",
//     "Photos/Photo 11.jpeg",
//     "Photos/Photo 12.jpeg",
//     "Photos/Photo 13.jpeg",
//     "Photos/Photo 14.jpeg",
//   ];

//   // Optional captions for each image (index-based)
//   const captions = [
//     "BrandFlow — Studio Capture",
//     "Team brainstorming session",
//     "Brand photoshoot — behind the scenes",
//     "Mumbai city activation",
//     "Event: Launch night",
//     "Creative direction sketch",
//     "Packaging mockup",
//     "Social media content day",
//     "Client workshop",
//     "Strategy meeting",
//     "Product shoot",
//     "Office vibe",
//     "Field marketing",
//     "Campaign launch",
//   ];

//   // IntersectionObserver — reveal images as they come into view
//   useEffect(() => {
//     const nodes = gridRef.current?.querySelectorAll("[data-index]") || [];
//     if (!nodes.length) return;

//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           const i = Number(entry.target.getAttribute("data-index"));
//           if (entry.isIntersecting) {
//             setVisible((s) => (s.includes(i) ? s : [...s, i]));
//             observer.unobserve(entry.target);
//           }
//         });
//       },
//       { root: null, rootMargin: "0px", threshold: 0.12 }
//     );

//     nodes.forEach((n) => observer.observe(n));
//     return () => observer.disconnect();
//   }, []);

//   // keydown for ESC to close modal
//   useEffect(() => {
//     const onKey = (e) => {
//       if (e.key === "Escape") setSelected(null);
//     };
//     window.addEventListener("keydown", onKey);
//     return () => window.removeEventListener("keydown", onKey);
//   }, []);

//   return (
//     <section className="bg-primary-color py-16 px-6">
//       <div className="max-w-6xl mx-auto">
//         <h2 className="text-4xl font-semibold text-highlight-color text-center mb-8">
//           Gallery
//         </h2>

//         {/* Filters / Intro (optional) */}
//         <p className="text-center text-highlight-color/75 max-w-2xl mx-auto mb-10">
//           A curated selection of our work — photos, shoots, activations and
//           behind-the-scenes moments.
//         </p>

//         {/* Grid */}
//         <div
//           ref={gridRef}
//           className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
//         >
//           {photos.map((src, idx) => (
//             <figure
//               key={idx}
//               data-index={idx}
//               className={`
//                 relative rounded-2xl overflow-hidden
//                 bg-white/5 border border-white/10
//                 shadow-lg transform transition-all duration-400
//                 ${
//                   visible.includes(idx)
//                     ? "opacity-100 translate-y-0"
//                     : "opacity-0 translate-y-6"
//                 }
//               `}
//             >
//               {/* Glassy tile */}
//               <div className="relative h-72 sm:h-80 lg:h-64">
//                 <img
//                   src={src}
//                   alt={captions[idx] || `Photo ${idx + 1}`}
//                   loading="lazy"
//                   className="w-full h-full object-cover transition-transform duration-500 ease-out transform hover:scale-105"
//                 />

//                 {/* Hover caption overlay */}
//                 <figcaption
//                   className="absolute inset-0 flex items-end p-4 bg-gradient-to-t from-black/50 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300"
//                   aria-hidden={!visible.includes(idx)}
//                 >
//                   <div className="backdrop-blur-md bg-white/5 rounded-md px-3 py-2">
//                     <h3 className="text-sm font-semibold text-highlight-color">
//                       {captions[idx] || `Photo ${idx + 1}`}
//                     </h3>
//                     <p className="text-xs text-highlight-color/80 mt-1">
//                       Click to open
//                     </p>
//                   </div>
//                 </figcaption>
//               </div>

//               {/* Footer area for labels or actions */}
//               <div className="p-4 flex items-center justify-between bg-white/2">
//                 <div>
//                   <p className="text-sm font-medium text-highlight-color">
//                     {captions[idx] || `Photo ${idx + 1}`}
//                   </p>
//                   <p className="text-xs text-highlight-color/70">BrandFlow</p>
//                 </div>

//                 <button
//                   onClick={() => setSelected({ src, idx })}
//                   className="ml-4 inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-color text-black font-semibold hover:opacity-95 transition"
//                 >
//                   View
//                 </button>
//               </div>
//             </figure>
//           ))}
//         </div>

//         {/* Load more (simple incremental) */}
//         <div className="flex justify-center mt-10">
//           <button
//             onClick={() =>
//               // reveal more images by adding unseen indexes into visible (simple approach)
//               setVisible((curr) => {
//                 const next = [];
//                 for (let i = 0; i < photos.length; i++) {
//                   if (!curr.includes(i) && next.length < 6) next.push(i);
//                 }
//                 return Array.from(new Set([...curr, ...next]));
//               })
//             }
//             className="px-8 py-3 rounded-full bg-secondary-color text-black font-semibold shadow hover:scale-[1.02] transition"
//           >
//             Load more
//           </button>
//         </div>
//       </div>

//       {/* Modal / Lightbox */}
//       {selected && (
//         <div
//           className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4"
//           onClick={() => setSelected(null)}
//         >
//           <div
//             className="max-w-4xl w-full rounded-2xl overflow-hidden bg-primary-color border border-white/10 shadow-2xl"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="relative">
//               <img
//                 src={selected.src}
//                 alt={selected.caption}
//                 className="w-full h-[70vh] object-contain bg-black"
//               />
//               <button
//                 onClick={() => setSelected(null)}
//                 className="absolute top-4 right-4 bg-white/10 text-highlight-color rounded-full w-10 h-10 flex items-center justify-center hover:bg-white/20"
//               >
//                 ✕
//               </button>
//             </div>

//             <div className="p-5 bg-white/3 flex items-center justify-between">
//               <div>
//                 <h3 className="text-lg font-semibold text-highlight-color">
//                   {captions[selected.idx] || "Photo"}
//                 </h3>
//                 <p className="text-sm text-highlight-color/70">BrandFlow</p>
//               </div>

//               <a
//                 href={selected.src}
//                 download
//                 className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-secondary-color text-black font-semibold"
//               >
//                 Download
//               </a>
//             </div>
//           </div>
//         </div>
//       )}
//     </section>
//   );
// }

// export default GalleryPremium;

import React, { useEffect, useRef, useState, useCallback } from "react";

function LazyImage({ src, alt, className }) {
  const imgRef = useRef(null);
  const [loadedSrc, setLoadedSrc] = useState(null);

  useEffect(() => {
    let observer;
    const el = imgRef.current;
    if (!el) {
      // fallback: set src immediately
      setLoadedSrc(src);
      return;
    }

    if ("IntersectionObserver" in window) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setLoadedSrc(src);
              observer.unobserve(el);
            }
          });
        },
        { rootMargin: "200px" }
      );
      observer.observe(el);
    } else {
      // older browsers
      setLoadedSrc(src);
    }

    return () => observer && observer.disconnect();
  }, [src]);

  return (
    <img
      ref={imgRef}
      src={loadedSrc || ""}
      data-src={src}
      alt={alt}
      className={className}
      loading="lazy"
      style={{ transition: "opacity .35s ease", opacity: loadedSrc ? 1 : 0 }}
    />
  );
}

export default function GalleryPremium() {
  // Important: first path uses local file upload path from the conversation.
  const photos = [
    "Photos/Photo 1.jpeg",
    "Photos/Photo 2.jpeg",
    "Photos/Photo 3.jpeg",
    "Photos/Photo 4.jpeg",
    "Photos/Photo 5.jpeg",
    "Photos/Photo 6.jpeg",
    "Photos/Photo 7.jpeg",
    "Photos/Photo 8.jpeg",
    "Photos/Photo 9.jpeg",
    "Photos/Photo 10.jpeg",
    "Photos/Photo 11.jpeg",
    "Photos/Photo 12.jpeg",
    "Photos/Photo 13.jpeg",
    "Photos/Photo 14.jpeg",
    "Photos/Photo 15.jpeg",
    "Photos/Photo 16.jpeg",
    "Photos/Photo 17.jpeg",
    "Photos/Photo 18.jpeg",
    "Photos/Photo 19.jpeg",
    "Photos/Photo 20.jpeg",
    "Photos/Photo 21.jpeg",
    "Photos/Photo 22.jpeg",
    "Photos/Photo 23.jpeg",
    "Photos/Photo 24.jpeg",
    "Photos/Photo 25.jpeg",
    "Photos/Photo 26.jpeg",
    "Photos/Photo 27.jpeg",
    "Photos/Photo 28.jpeg",
    "Photos/Photo 29.jpeg",
    "Photos/Photo 30.jpeg",
  ];

  const BATCH = 12; // how many to initially show / add per load
  const [visibleCount, setVisibleCount] = useState(BATCH);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const sentinelRef = useRef(null);

  // load more handler (manual)
  const loadMore = useCallback(() => {
    setVisibleCount((v) => Math.min(photos.length, v + BATCH));
  }, [photos.length]);

  // infinite-load on sentinel visible
  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel) return;
    if (!("IntersectionObserver" in window)) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadMore();
          }
        });
      },
      { rootMargin: "300px" }
    );

    io.observe(sentinel);
    return () => io.disconnect();
  }, [loadMore]);

  // close modal on ESC
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setSelectedIndex(null);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="bg-primary-color text-highlight-color min-h-screen">
      <div className="max-w-7xl mx-auto mt-12 px-6 py-16">
        {/* Title */}
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-semibold text-highlight-color">
            Gallery
          </h2>
          <p className="mt-2 text-gray-400 max-w-2xl mx-auto">
            A curated collection of BrandFlow visuals - campaigns, shoots and
            moments. Click any photo to view larger.
          </p>
        </div>

        {/* Controls */}
        <div className="flex items-center justify-between mb-6 gap-4">
          <div className="flex items-center gap-3">
            {/* <div className="text-sm text-gray-400">Showing</div>
            <div className="px-3 py-1 rounded-full bg-white/5 text-sm">
              {Math.min(visibleCount, photos.length)} / {photos.length}
            </div> */}
          </div>

          <div className="flex gap-3">
            {/* <button
              onClick={() => setVisibleCount(BATCH)}
              className="text-sm px-4 py-2 rounded-md border border-white/10 bg-white/5 hover:bg-white/10 transition"
            >
              Reset
            </button>

            <button
              onClick={loadMore}
              className="text-sm px-4 py-2 rounded-md bg-secondary-color text-black font-semibold hover:brightness-95 transition"
            >
              Load More
            </button> */}
          </div>
        </div>

        {/* Grid */}
        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
          aria-live="polite"
        >
          {photos.slice(0, visibleCount).map((photo, idx) => (
            <article
              key={idx}
              className="group rounded-2xl overflow-hidden relative bg-white/5 border border-white/10 shadow-lg"
            >
              {/* image wrapper */}
              <div
                className="w-full h-64 md:h-72 lg:h-64 overflow-hidden cursor-pointer"
                onClick={() => setSelectedIndex(idx)}
              >
                <div className="w-full h-full transform-gpu group-hover:scale-105 transition duration-500">
                  <LazyImage
                    src={photo}
                    alt={`Gallery pic ${idx + 1}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              {/* glass caption */}
              <div className="absolute left-4 right-4 bottom-4 p-3 rounded-lg bg-black/30 backdrop-blur-md border border-white/10 text-sm">
                <div className="flex items-center justify-between gap-4">
                  <div className="text-white/90 font-medium">
                    Photo {idx + 1}
                  </div>
                  <div className="text-white/70 text-xs">Click to enlarge</div>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* sentinel for infinite load */}
        <div ref={sentinelRef} className="h-6" />

        {/* Load more button fallback */}
        {visibleCount < photos.length && (
          <div className="text-center mt-8">
            <button
              onClick={loadMore}
              className="inline-block px-6 py-3 rounded-full bg-secondary-color text-black font-semibold shadow-md hover:brightness-95 transition"
            >
              Load more photos
            </button>
          </div>
        )}
      </div>

      {/* Lightbox Modal */}
      {selectedIndex !== null && (
        <Lightbox
          photos={photos}
          startIndex={selectedIndex}
          onClose={() => setSelectedIndex(null)}
        />
      )}
    </div>
  );
}

/* -------------------------
   LIGHTBOX COMPONENT
   ------------------------- */
function Lightbox({ photos, startIndex = 0, onClose }) {
  const [index, setIndex] = useState(startIndex);

  useEffect(() => {
    setIndex(startIndex);
  }, [startIndex]);

  const prev = useCallback(() => {
    setIndex((i) => (i === 0 ? photos.length - 1 : i - 1));
  }, [photos.length]);

  const next = useCallback(() => {
    setIndex((i) => (i === photos.length - 1 ? 0 : i + 1));
  }, [photos.length]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4"
      onClick={onClose}
    >
      <div
        className="max-w-5xl w-full relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-white/90 bg-black/30 rounded-full p-2 hover:bg-black/20 transition"
          aria-label="Close"
        >
          ✕
        </button>

        <button
          onClick={prev}
          className="absolute left-4 top-1/2 -translate-y-1/2 text-white/90 bg-black/30 rounded-full p-2 hover:bg-black/20 transition"
          aria-label="Previous"
        >
          ‹
        </button>

        <button
          onClick={next}
          className="absolute right-4 top-1/2 -translate-y-1/2 text-white/90 bg-black/30 rounded-full p-2 hover:bg-black/20 transition"
          aria-label="Next"
        >
          ›
        </button>

        <div className="rounded-xl overflow-hidden bg-white/5 border border-white/10 shadow-2xl">
          <img
            src={photos[index]}
            alt={`Photo ${index + 1}`}
            className="w-full h-auto max-h-[80vh] object-contain bg-black"
          />
        </div>

        <div className="mt-4 text-center text-white/80">
          Photo {index + 1} of {photos.length}
        </div>
      </div>
    </div>
  );
}
